import React, { Component } from 'react';
import "swiper/css";
import 'swiper/css/thumbs';
import { Swiper, SwiperSlide } from "swiper/react";
import { Big3Common, bootstrap } from '../../../js/IncludeManager';
import { GoodsPhoto, Confirm, Alert, NoResult } from '../../../js/ComponentManager';
import { Footer } from '../../Common/Footer';
import { DataContext } from '../../Layout';
import { FolderEdit } from './FolderEdit';

/* 개발담당:양유빈
 * 화면기능:상품 찜리스트
 * 세부설명:
*/

export class BoorkMarkGoods extends Component {
    static displayName = BoorkMarkGoods.name;
    static contextType = DataContext;

    constructor(props) {
        super(props);
        this.state = {
            TotalCount: 0,
            BookMarkList: [],
            FolderList: [],
            SelectModel: [],
            GoodsInfo: { Uid: "", Goods_No: 0 },
            Folder_No: "",
            Edit_Yn: "N",
        };
        this.CsName = Big3Common.ContentState;
        this.ref_FolderEdit = React.createRef();
        
        this.handleGoodsLink_Click = this.handleGoodsLink_Click.bind(this);
        this.CallBoorkMarkGoodsData = this.CallBoorkMarkGoodsData.bind(this);
        this.handleInit = this.handleInit.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);
        this.handle_onScroll = this.handle_onScroll.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleFolder_Edit = this.handleFolder_Edit.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.CallBokmkFolderList = this.CallBokmkFolderList.bind(this);
    }
    SearchModel = {
        Page_Number: 1,
        Page_Size: Big3Common.WebConfig.Page_Size,
        Folder_No: ""
    }
    //초기화
    componentDidMount() {
        //안드로이드 백버튼 제어
        window.addEventListener('scroll', this.handle_onScroll);

        const propSearchModel = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchModel, "");
        if (propSearchModel !== "") {
            this.SearchModel = propSearchModel;
            this.SearchModel.Page_Number = 1;
        }
        this.CallBoorkMarkGoodsData();
        this.CallBokmkFolderList();
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handle_onScroll);
    } 
    handle_onScroll() {
        if (Big3Common.WebConfig.ScrollEvent === false) {
            return false;
        }
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
            Big3Common.WebConfig.ScrollEvent = false;
            this.handleAddMore_Click();
        }
    }
    //폴더 리스트 조회
    async CallBokmkFolderList() {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/BookMark/GetMyBokmkFolderList', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let FolderList = JSON.parse(Data.dataTable);
                this.setState({
                    FolderList: FolderList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallBokmkFolderList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //찜한 상품 리스트 조회
    async CallBoorkMarkGoodsData(isAppend) {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/BookMark/GetMyBokmkGoodsList', this.SearchModel,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                const TotalCount = (this.SearchModel.Page_Number * this.SearchModel.Page_Size);
                if (isAppend) {
                    //페이징 처리
                    let GoodListPush = this.state.BookMarkList;
                    DataList.map(list => GoodListPush.push(list));
                    this.setState({
                        BookMarkList: GoodListPush,
                        TotalCount: TotalCount
                    });
                }
                else {
                    this.setState({
                        BookMarkList: DataList,
                        TotalCount: TotalCount
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallBoorkMarkGoodsData", e);
        }
        finally {
            Big3Common.WebConfig.ScrollEvent = true;
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleAddMore_Click() {
        this.SearchModel.Page_Number++;
        this.CallBoorkMarkGoodsData(true);
    }
    //상품상세 이동
    handleGoodsLink_Click(event, list) {
        
        this.props.RenderComponent("GoodsDtl", {
            [this.CsName.Uid]: list.uid,
            [this.CsName.Goods_No]: list.goods_no,
            [this.CsName.BackUrl]: "BoorkMarkGoods",
            [this.CsName.SearchModel]: this.SearchModel
        });
        event.preventDefault();
    }
    //상품상세 이동 Layer
    handleGoodsDtl_Click = async (event, list) => {
        this.context.Layout_GoodsDtl(
            {
                goods_no: list.goods_no,
                uid: list.uid,
                isshow: true,
                headhide: true,
                scrollevent: false
            });
        event.preventDefault();
    }
    //편집 > 상품선택
    handleSelect_Click(event, list) {
        let SelectList = this.state.SelectModel
        const check = SelectList.some(item => item.Goods_No === list.goods_no && item.Uid === list.uid);
        if (!check) {
            let GoodsInfo = Big3Common.Util.Cloen(this.state.GoodsInfo);
            GoodsInfo.Uid = list.uid;
            GoodsInfo.Goods_No = list.goods_no;
            SelectList.push(GoodsInfo);
        }
        else {
            SelectList = SelectList.filter(item => item.Goods_No !== list.goods_no);
        }
        this.setState({
            SelectModel: SelectList
        })
        event.preventDefault();
    }
    //초기화
    handleInit() {
        this.setState({
            SelectModel: [],
            Folder_No: "",
            Edit_Yn: "N"
        });
        this.SearchModel.Page_Number = 1;
        this.SearchModel.Folder_No = "";
        this.CallBoorkMarkGoodsData();
        this.CallBokmkFolderList();
    }
    //폴더선택
    handleFolder_Click = (event, folder_no) => {
        this.setState({
            Folder_No: folder_no
        });
        this.SearchModel.Folder_No = folder_no;
        this.SearchModel.Page_Number = 1;
        this.CallBoorkMarkGoodsData();
        event.preventDefault();
    }
    handleEditClick() {
        if (this.state.Edit_Yn === 'Y') {
            this.setState({
                Edit_Yn: 'N',
                SelectModel: []
            });
        }
        else {
            this.setState({
                Edit_Yn: 'Y',
                SelectModel: []
            });
        }
    }
    handleFolder_Edit(event, edit_code, SelectModel) {
        if (edit_code === 'E') {
            this.ref_FolderEdit.current.CallBokmkFolderList(edit_code, '')
            Big3Common.ModalAlert(bootstrap, 'FolderEdit');
        }
        else if (edit_code === 'M') {
            this.ref_FolderEdit.current.CallBokmkFolderList(edit_code, SelectModel)
            Big3Common.ModalAlert(bootstrap, 'FolderEdit');
        }
        event.preventDefault();
    }
    //도매상세 이동
    async handleDelete_Click(event) {
        try {
            let Data = await Big3Common.Post("api/MyPage/BookMark/DeleteBokmkGoods",
                {
                    SelectList: this.state.SelectModel,
                },
                true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Title: Data.message });
            }
            else {
                this.setState({ Title: Data.message });
            }
            Big3Common.ModalAlert(bootstrap, "DeleteAlert");
            this.handleInit();
            this.CallBoorkMarkGoodsData();
        }
        catch (e) {
            console.log("handle_Click: ", e)
        }
    }
    Folderrender() {
        const Folder_No = this.state.Folder_No;
        const FolderList = this.state.FolderList;
        function SwiperClassName(text, folder_no, folder_name) {
            let len = folder_name.length
            let Css = text
            if (len > 3) {
                Css += ` folder_t${len}`;
            }
            else {
                Css += " folder_t3";
            }

            if (folder_no === Folder_No) {
                Css += " selected";
            }
            return Css
        }

        return (
            <Swiper watchSlidesProgress={true} slidesPerView="auto" className="folder_box">
                <SwiperSlide className={this.state.Folder_No === "" ? "folder folder_t4 selected" : "folder folder_t4"} onClick={(e) => { this.handleFolder_Click(e, "") }}>
                    <div>전체보기</div>
                </SwiperSlide>
                {
                    FolderList.map((list, idx) =>
                        <SwiperSlide className={SwiperClassName("folder", list.folder_no, list.folder_name)}
                            key={idx}
                            onClick={(e) => { this.handleFolder_Click(e, list.folder_no) }}>
                            <div> {list.folder_name}</div>
                        </SwiperSlide>

                    )}
                <SwiperSlide className="folder folder_t3" style={{ visibility: 'hidden' }}>
                    {/* 공백*/}
                </SwiperSlide>
                <div className="folder_edit">
                    <button className="edit_btn" onClick={(e) => { this.handleFolder_Edit(e, 'E', '') }}></button>
                </div>
            </Swiper>
        )
    }
    Goodsrender() {
        if (this.state.BookMarkList.length === 0) {
            return false;
        }
        let BookMarkList = this.state.BookMarkList;

        if (this.state.Edit_Yn === "N") {
            return (
                <div className="recent_poroducts recent_poroducts_v2 row row-cols-2">
                    {
                        BookMarkList.map(list =>
                            <div className="product" key={list.file_no} onClick={(e) => { this.handleGoodsDtl_Click(e, list); }}>
                                <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                    Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                    CallBack={this.CallBoorkMarkGoodsData}
                                    SoldoutYn={list.soldout_yn}
                                    SimilarityYn="N"
                                    Edit_Yn={this.state.Edit_Yn}
                                />
                                <div className="shop_name">{list.org_nm}</div>
                                <div className="product_name">{list.goods_nm}</div>
                                <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                                {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                            </div>
                        )
                    }
                    {this.state.TotalCount === this.state.BookMarkList.length ? <div className="more_btn_box"><button className="more_btn" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
                </div>
            )
        }
        else {
            return (
                <div className="recent_poroducts recent_poroducts_v2 row row-cols-2">
                    {
                        BookMarkList.map(list =>
                            <div className="product" key={list.file_no} onClick={(e) => { this.handleSelect_Click(e, list); }}>
                                <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                    Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                    CallBack={this.CallBoorkMarkGoodsData}
                                    SoldoutYn={list.soldout_yn}
                                    SimilarityYn="N"
                                    Edit_Yn={this.state.Edit_Yn}
                                    SelectList={this.state.SelectModel}
                                />
                                <div className="shop_name">{list.org_nm}</div>
                                <div className="product_name">{list.goods_nm}</div>
                                <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                                {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                            </div>
                        )
                    }
                    {this.state.TotalCount === this.state.BookMarkList.length ? <div className="more_btn_box"><button className="more_btn" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
                </div>
            )
        }
    }
    render() {
        let Goodsrender = this.Goodsrender();
        let Folderrender = this.Folderrender();
        let cnt = this.state.BookMarkList.length;
        let SelectModel = this.state.SelectModel
        return (
            <>
                <div id="parent_goods_list">
                    <div className="tap_box tap_box_v2">
                        <div className="n_tap"><div className="alert_tap tap_on">찜한 상품</div></div>
                        <div className="n_tap"><div className="alert_tap" onClick={() => { this.props.RenderComponent('BoorkMarkStore') }}>찜한 매장</div></div>
                    </div>
                    <div className="m_f_margin d_padding bookmark_wrap container_box">
                        {Folderrender}
                        {this.state.Edit_Yn === "N" ? 
                            <div className="title_box">
                                <div className="title">상품 {cnt}</div>
                                <button className="edit_btn" onClick={this.handleEditClick}>편집</button>
                            </div>
                            :
                            <div className="title_box">
                                <div className="title">1개 상품 선택</div>
                                <button className="edit_btn2" onClick={this.handleEditClick}>편집완료</button>
                            </div>
                        }
                        
                        {Goodsrender}
                    </div>
                    <FolderEdit
                        id="FolderEdit"
                        ref={this.ref_FolderEdit}
                        CallBack={this.handleInit}
                        CallBokmkFolderList={this.CallBokmkFolderList}
                    />
                    <Confirm
                        id="DeleteConfirm"
                        title="선택한 상품을 삭제하시겠습니까?"
                        ConfirmClick={(e) => {
                            setTimeout(() => {
                                Big3Common.ModalClose(bootstrap, 'DeleteConfirm');
                            }, 500);
                            this.handleDelete_Click(e);
                        }}
                    />
                    <Alert
                        id="DeleteAlert"
                        title={this.state.Title}
                        content={this.state.Content}
                    />
                    <NoResult
                        Visible={this.state.BookMarkList.length === 0 ? true : false}
                        Top={"50%"}
                    />
                </div>
                {this.state.Edit_Yn === "N" ?
                    <Footer fillName="icon3"/>
                    :
                    <div className="bookmark_edit_box">
                        <button onClick={(e) => { this.handleFolder_Edit(e, 'M', SelectModel) }}>
                            <span></span>폴더이동
                        </button>

                        <button onClick={() => { Big3Common.ModalAlert(bootstrap, 'DeleteConfirm'); }}>
                            <span></span>삭제하기
                        </button>
                    </div>
                }
            </>
        );
    }
}
